// extracted by mini-css-extract-plugin
export var buttons = "_98-0";
export var buttonsActive = "_98-h";
export var cancelConfirm = "_98-1";
export var closeButton = "_98-2";
export var column = "_98-3";
export var container = "_98-4";
export var detailHeader = "_98-6";
export var detailTitle = "_98-7";
export var detailsContent = "_98-5";
export var header = "_98-8";
export var headerWithClose = "_98-9";
export var icon = "_98-a";
export var infoIcon = "_98-c";
export var informationContainer = "_98-b";
export var sideDrawer = "_98-d";
export var sideDrawerOpen = "_98-e";
export var stickyFooter = "_98-f";
export var typeOption = "_98-g";